import { Component, Input, Output, Inject, EventEmitter } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwWafer
 * @module mw.components.wafers
 *
 * @param {string} [icon] - Name of an icon to be added to the wafer.  Should be in the same format supported by the 'md-svg-icon' param of an `<md-icon>`
 * @param {boolean} [readonly=false] - This value determines if the wafer should show a remove button.
 * @param {expression} [on-remove] - Angular expression to evaluate on click of the remove button.
 *
 * @description
 * `<mw-wafer>` is a component that renders a wafer according to the Meltwater UX guidelines.  It is a flexible component that can be used to compose wafers in many different contexts such as dialogs or inline cards.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-wafer icon="{{wafer.icon}}" on-remove="$ctrl.click(wafer)" readonly="wafer.readonly">{{wafer.label}}</mw-wafer>
 * </hljs>
 *
 */
@Component({
  selector: 'mw-wafer',
  template: `
        <md-list-item class="mw-wafer">
            <mw-icon ng-if="::$ctrl.icon" svg-icon="{{::$ctrl.icon}}"></mw-icon>
            <span mw-autotip flex>
                <ng-transclude></ng-transclude>
            </span>
            <button class="mw-wafer__transparent-button"></button>
            <mw-icon-button
                svg-icon="navigation:ic_close_24px"
                class="md-icon-button"
                ng-click="::$ctrl.onRemoveClick($event)"
                ng-if="::!$ctrl.readonly"
                size="sm"
                tooltip="Remove"
                hover="true">
            </mw-icon-button>
        </md-list-item>
    `,
  legacy: {
    transclude: true
  }
})
export class WaferComponent {
  @Input('@') icon: string;
  @Input('<') readonly: boolean = false;
  @Output() onRemove = new EventEmitter<any>();

  constructor() {
    'ngInject';
  }

  onRemoveClick(event) {
    this.onRemove.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/wafers/wafer.component.ts